module.exports = __webpack_public_path__ + "static/media/pla_ski_bin.8d1c35fc.png";